<template>
    <div class="page">
      <ion-grid padding>
        <ion-row class="ion-text-center">
          <ion-col>
            <img class="offerImage" :src= this.imagePath />
          </ion-col>
        </ion-row>
        <!-- <ion-row class="rectangle ion-text-center">
          <ion-col>
            <p>{{ displayErrorMsg }}</p>
          </ion-col>
        </ion-row> -->
      </ion-grid>
      <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
      </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel  } from "@ionic/vue";
import { migratedTryParseServiceError } from "../../service";
import { LocalStorage } from "../../data/localstorage";
import { config } from "../../config";
import axios from "axios";
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
  name: 'discountOffer',
  components: {
      IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel
  },
  async mounted() {
    let userProfile = new LocalStorage().userProfile
      let userStateCode = userProfile.address.state.code;
    let data = {
      state: userStateCode,
      selectedDate: moment(new Date()).format('YYYY-MM-DD')
    }
    try {
      let response = await axios.post(config.api.host + "/checkDiscountOffers", data, {
        headers: {
          Authorization: new LocalStorage().authToken
        }
      });
      let imagePath= "https://devapi.rapidevcharge.com/common/static/images/"+response.data.data[0].filename;
      let fNmae = response.data.data[0].filename;
      this.imagePath = imagePath;
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      // this.displayErrorMsg = error.response.data.errors[0].detail;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
      // new ToastUtils().presentToast(error.response.data.errors[0].detail)
    }
    
  },
  data() {
    return {
      imagePath: '',
      displayErrorMsg: "",
      loaderTab: true
    }
  },
  methods: {
    setCurrentTab() {
    }
  }
})
</script>

<style scoped>
.offerImage {
  width: 70%;
}
@media (max-width: 768px) {
  .offerImage {
    width: 100%;
  }
}
</style>